import instance from '../../../../api/axios'
import {
  CreateRecipe,
  Recipe,
  PaginatedRecipesResponse,
  RecipeListRequest,
} from '../types/recipe'

export const loadRecipes = async (): Promise<Recipe[]> => {
  const response = await instance.get('/recipes')
  return response.data
}

export const loadRecipeList = async (
  request: RecipeListRequest,
): Promise<PaginatedRecipesResponse> => {
  const params: Record<string, string> = {
    page: String(request.page),
    limit: String(request.limit || 25),
  }

  if (request.name?.trim()) {
    params.name = request.name.trim()
  }

  const response = await instance.get('/recipes/list', {
    params,
  })

  return response.data
}

export const loadRecipe = async (id: string): Promise<Recipe> => {
  const response = await instance.get(`/recipes/${id}`)
  return response.data
}

export const saveRecipe = async (recipe: CreateRecipe): Promise<Recipe> => {
  const response = await instance.post('/recipes', recipe)
  return response.data
}

export const modifyRecipe = async (recipe: Recipe): Promise<Recipe> => {
  const response = await instance.put('/recipes', {
    id: recipe.id,
    name: recipe.name,
    description: recipe.description,
    ingredients: recipe.ingredients,
  })
  return response.data
}

export const removeRecipe = async (id: string): Promise<string> => {
  const response = await instance.delete(`/recipes/${id}`)
  return response.data
}
